// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================================
   MODERN PLAYLIST MANAGER
   - Dark/Light Theme Support
   - Mobile & Desktop Responsive
   - Clean, Professional Design
=============================================== */

/* ===== CSS VARIABLES (THEME SYSTEM) ===== */
:root {
  /* Light Theme Colors */
  --bg-primary: #ffffff;
  --bg-secondary: #f8f9fa;
  --bg-tertiary: #f1f3f5;
  
  --text-primary: #1a1a1a;
  --text-secondary: #4a5568;
  --text-tertiary: #718096;
  
  --border-color: #e2e8f0;
  --border-hover: #cbd5e0;
  
  --accent-primary: #3b82f6;
  --accent-hover: #2563eb;
  --accent-light: #dbeafe;
  
  --success: #10b981;
  --success-light: #d1fae5;
  
  --danger: #ef4444;
  --danger-light: #fee2e2;
  
  --warning: #f59e0b;
  --warning-light: #fef3c7;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  
  /* Spacing */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 14px;
  
  /* Transitions */
  --transition-fast: 150ms ease;
  --transition-base: 200ms ease;
  --transition-slow: 300ms ease;
}

/* ===== DARK THEME ===== */
[data-theme="dark"] {
  --bg-primary: #0f172a;
  --bg-secondary: #1e293b;
  --bg-tertiary: #334155;
  
  --text-primary: #f1f5f9;
  --text-secondary: #cbd5e1;
  --text-tertiary: #94a3b8;
  
  --border-color: #334155;
  --border-hover: #475569;
  
  --accent-primary: #3b82f6;
  --accent-hover: #60a5fa;
  --accent-light: #1e3a8a;
  
  --success: #10b981;
  --success-light: #064e3b;
  
  --danger: #ef4444;
  --danger-light: #7f1d1d;
  
  --warning: #f59e0b;
  --warning-light: #78350f;
  
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.5);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.5);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.5);
}

/* ===== BASE STYLES ===== */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background: var(--bg-secondary);
  color: var(--text-primary);
  line-height: 1.6;
  transition: background var(--transition-base), color var(--transition-base);
}

/* ===== PLAYLIST PAGE CONTAINER ===== */
.playlist-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
  min-height: 100vh;
}

@media (max-width: 768px) {
  .playlist-page {
    padding: 16px;
  }
}

/* ===== TYPOGRAPHY ===== */
.playlist-page h1 {
  font-size: clamp(24px, 5vw, 32px);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 24px;
  letter-spacing: -0.02em;
}

.playlist-page h2 {
  font-size: clamp(20px, 4vw, 24px);
  font-weight: 600;
  color: var(--text-primary);
  margin: 32px 0 16px;
}

.playlist-page h3 {
  font-size: clamp(16px, 3vw, 18px);
  font-weight: 600;
  color: var(--text-secondary);
  margin: 24px 0 12px;
}

/* ===== BUTTON SYSTEM ===== */
.playlist-page button,
.playlist-page .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  min-height: 44px;
  padding: 12px 20px;
  
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  
  border: none;
  border-radius: var(--radius-md);
  
  background: var(--accent-primary);
  color: #ffffff;
  
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  
  transition: all var(--transition-fast);
  
  box-shadow: var(--shadow-sm);
}

.playlist-page button:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.playlist-page button:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}

.playlist-page button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Button Variants */
.playlist-page button.secondary {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  box-shadow: none;
}

.playlist-page button.secondary:hover {
  background: var(--bg-secondary);
  border-color: var(--border-hover);
}

.playlist-page button.danger {
  background: transparent;
  color: var(--danger);
  box-shadow: none;
  padding: 8px 12px;
  min-height: auto;
}

.playlist-page button.danger:hover {
  background: var(--danger-light);
  transform: scale(1.05);
}

.playlist-page button.selected {
  background: var(--accent-light);
  color: var(--accent-primary);
  border: 2px solid var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.playlist-page button.icon-only {
  width: 44px;
  padding: 0;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
}

.playlist-page button.icon-only:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

/* ===== INPUT FIELDS ===== */
.playlist-page input[type="text"],
.playlist-page input[type="number"],
.playlist-page select {
  width: 100%;
  height: 44px;
  padding: 0 16px;
  
  font-size: 14px;
  font-family: inherit;
  
  background: var(--bg-primary);
  color: var(--text-primary);
  
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  
  transition: all var(--transition-fast);
}

.playlist-page input:focus,
.playlist-page select:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.playlist-page input::placeholder {
  color: var(--text-tertiary);
}

.duration-input {
  width: 80px !important;
}

/* ===== PLAYLIST ADD SECTION ===== */
.playlist-add {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  padding: 20px;
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

@media (max-width: 768px) {
  .playlist-add {
    flex-direction: column;
  }
  
  .playlist-add input {
    width: 100%;
  }
}

/* ===== PLAYLIST LIST ===== */
.playlist-list {
  display: grid;
  gap: 12px;
  margin-bottom: 32px;
}

.playlist-row {
  display: grid;
  grid-template-columns: 1fr auto auto auto auto;
  align-items: center;
  gap: 16px;
  
  padding: 16px 20px;
  
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  
  cursor: pointer;
  
  transition: all var(--transition-fast);
  
  box-shadow: var(--shadow-sm);
}

.playlist-row:hover {
  border-color: var(--accent-primary);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.playlist-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--accent-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.playlist-row span {
  font-size: 14px;
  color: var(--text-secondary);
  white-space: nowrap;
}

@media (max-width: 768px) {
  .playlist-row {
    grid-template-columns: 1fr auto;
    gap: 12px;
  }
  
  .playlist-row span {
    grid-column: 1 / -1;
    font-size: 12px;
  }
}

/* ===== ASSET LIST ===== */
.asset-list {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  margin-bottom: 24px;
}
.asset-index {
  font-weight: 700;
  color: var(--text-secondary);
  width: 30px;
  text-align: center;
  background: var(--bg-tertiary);
  border-radius: 6px;
  padding: 4px 0;
  font-size: 13px;
}
.asset-row {
  display: grid;
  grid-template-columns: 40px 80px minmax(0, 1fr) auto auto auto;
  align-items: center;
  gap: 16px;

  padding: 12px 16px;

  border-bottom: 1px solid var(--border-color);

  background: var(--bg-primary);

  transition: all var(--transition-fast);
}
.asset-index-placeholder {
  width: 30px;
}
.asset-row:last-child {
  border-bottom: none;
}

.asset-row:hover {
  background: var(--bg-secondary);
}

.asset-row.selected {
  background: var(--bg-secondary);
  cursor: pointer;
}

/* Keep checkbox in same column (5) in unselected list so it doesn't shift */
.unselected-list .asset-row input[type="checkbox"] {
  grid-column: 5;
}

.asset-row:active {
  cursor: grabbing;
}

.asset-row img,
.asset-row video {
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm);
  flex-shrink: 0;
  min-width: 0;
}

.asset-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
  min-width: 0;
}

.asset-info span {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.asset-info small {
  font-size: 12px;
  color: var(--text-tertiary);
}

@media (max-width: 768px) {
  .asset-row {
    grid-template-columns: 30px 60px minmax(0, 1fr) auto auto auto;
    gap: 12px;
  }
  .asset-info{
    text-align: center;
  }

  .asset-row img,
  .asset-row video {
    width: 60px;
    height: 45px;
  }
}

/* ===== PLAYLIST ASSETS (GRID VIEW) ===== */
.playlist-assets {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.playlist-asset {
  position: relative;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  transition: all var(--transition-fast);
}

.playlist-asset:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.playlist-asset img {
  width: 100%;
  height: 120px;
  object-fit: cover;
  display: block;
}

.playlist-asset button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  min-height: auto;
  padding: 0;
  
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  
  border-radius: 50%;
  
  font-size: 18px;
}

@media (max-width: 768px) {
  .playlist-assets {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 12px;
  }
  
  .playlist-asset img {
    height: 90px;
  }
}

/* ===== MODAL SYSTEM ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  z-index: 10000;
  
  animation: fadeIn var(--transition-base);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal {
  width: 700px;
  max-width: 95vw;
  max-height: 90vh;
  
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  
  box-shadow: var(--shadow-xl);
  
  display: flex;
  flex-direction: column;
  
  overflow: hidden;
  
  animation: slideUp var(--transition-slow);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
}

.modal-body {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid var(--border-color);
  
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

@media (max-width: 768px) {
  .modal {
    max-width: 100vw;
    max-height: 100vh;
    border-radius: 0;
  }
}

/* ===== PREVIEW OVERLAY ===== */
.preview-overlay {
  position: fixed;
  inset: 0;
  
  background: #000000;
  
  z-index: 9999;
  
  display: flex;
  flex-direction: column;
  
  overflow: hidden;
}

.preview-stage {
  width: 100vw;
  height: 100vh;
  
  display: flex;
  flex-direction: column;
}

.preview-media-wrapper {
  flex: 1 1;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  overflow: hidden;
}

.preview-media {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.preview-media.cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-close {
  position: fixed;
  top: 20px;
  right: 20px;
  
  width: 48px;
  height: 48px;
  
  background: var(--danger);
  color: #ffffff;
  
  border: none;
  border-radius: 50%;
  
  font-size: 24px;
  font-weight: bold;
  
  cursor: pointer;
  
  z-index: 999999;
  
  box-shadow: var(--shadow-xl);
  
  transition: all var(--transition-fast);
}

.preview-close:hover {
  background: #dc2626;
  transform: scale(1.1);
}

/* ===== TICKER SYSTEM ===== */
.display-ticker {
  position: relative;
  width: 100%;
  overflow: hidden;
  
  display: flex;
  align-items: center;
  
  z-index: 10001;
}

.display-ticker-track {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  
  will-change: transform;
  
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.ticker-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.display-ticker.landscape .ticker-item {
  margin-right: 80px;
}

.display-ticker-text {
  display: inline-block;
  font-weight: 600;
  letter-spacing: 1px;
  transform: skewX(-12deg);
  line-height: 1;
  padding-top: 2px;
  color: inherit;
  text-shadow: 0 0 6px currentColor;
}

/* Landscape Ticker Animations */
.display-ticker.landscape.left .display-ticker-track {
  animation-name: display-ticker-left;
}

.display-ticker.landscape.right .display-ticker-track {
  animation-name: display-ticker-right;
}

@keyframes display-ticker-left {
  from { transform: translateX(100vw); }
  to { transform: translateX(-100%); }
}

@keyframes display-ticker-right {
  from { transform: translateX(-100%); }
  to { transform: translateX(100vw); }
}

/* Portrait Ticker */
.display-ticker.portrait {
  position: absolute;
  right: 0;
  top: 0;
  width: 60px;
  height: 100%;
  overflow: hidden;
}

.display-ticker.portrait .display-ticker-track {
  position: absolute;
  left: 50%;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 240px;
  
  transform: translateX(-50%) translateY(-120%);
  
  animation-name: ticker-portrait;
}

.display-ticker.portrait .display-ticker-text {
  display: inline-block;
  white-space: nowrap;
  
  transform: rotate(-90deg);
  transform-origin: center;
}

@keyframes ticker-portrait {
  from {
    transform: translateX(-50%) translateY(-120%);
  }
  to {
    transform: translateX(-50%) translateY(120%);
  }
}

/* Ticker Speeds */
.display-ticker.slow .display-ticker-track {
  animation-duration: 30s;
}

.display-ticker.medium .display-ticker-track {
  animation-duration: 15s;
}

.display-ticker.fast .display-ticker-track {
  animation-duration: 8s;
}

/* ===== COPY BUTTON ===== */
.copy-btn {
  background: none;
  border: none;
  color: var(--text-tertiary);
  font-size: 18px;
  padding: 8px;
  cursor: pointer;
  transition: all var(--transition-fast);
  border-radius: var(--radius-sm);
}

.copy-btn:hover {
  background: var(--bg-secondary);
  color: var(--accent-primary);
}

/* ===== UTILITY CLASSES ===== */
.text-muted {
  color: var(--text-tertiary);
}

.text-success {
  color: var(--success);
}

.text-danger {
  color: var(--danger);
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 999px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

.badge.success {
  background: var(--success-light);
  color: var(--success);
}

.badge.danger {
  background: var(--danger-light);
  color: var(--danger);
}

/* ===== LOADING STATES ===== */
.loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid var(--border-color);
  border-top-color: var(--accent-primary);
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ===== SCROLLBAR STYLING ===== */
.modal-body::-webkit-scrollbar,
.asset-list::-webkit-scrollbar {
  width: 8px;
}

.modal-body::-webkit-scrollbar-track,
.asset-list::-webkit-scrollbar-track {
  background: var(--bg-secondary);
}

.modal-body::-webkit-scrollbar-thumb,
.asset-list::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb:hover,
.asset-list::-webkit-scrollbar-thumb:hover {
  background: var(--border-hover);
}

/* ===== RESPONSIVE BREAKPOINTS ===== */
@media (max-width: 480px) {
  .playlist-page h1 {
    font-size: 24px;
  }
  
  .playlist-header {
    padding: 12px;
    display: flex;
  }
  
  .playlist-row {
    padding: 12px;
    display: flex;
    gap: 20px;
  }
  
  .asset-row {
    padding: 10px;
    grid-template-columns: 60px minmax(0, 1fr) auto auto auto;
  }
  
  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 16px;
  }
}

/* ===== PRINT STYLES ===== */
@media print {
  .playlist-page button,
  .preview-close,
  .copy-btn {
    display: none;
  }
  
  .playlist-page {
    padding: 0;
  }
  
  .asset-row,
  .playlist-row {
    box-shadow: none;
    border: 1px solid #ddd;
  }
}

/* ===== ACCESSIBILITY ===== */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

.playlist-page button:focus-visible,
.playlist-page input:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

/* ===== HIGH CONTRAST MODE ===== */
@media (prefers-contrast: high) {
  :root {
    --border-color: #000000;
    --text-secondary: #000000;
  }
  
  [data-theme="dark"] {
    --border-color: #ffffff;
    --text-secondary: #ffffff;
  }
}

.selected-assets-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 18px 0 10px;
}

.selected-assets-header h3 {
  margin: 0;
  font-size: 16px;
}

.selected-assets-header span {
  font-size: 14px;
  opacity: 0.8;
}
.available-assets-header {
  margin: 24px 0 10px;
}

.available-assets-header h3 {
  margin: 0;
  font-size: 16px;
}
* {
  outline: none;
}
h2.section-title {
  font-size: clamp(18px, 2vw, 22px);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/playlists.css"],"names":[],"mappings":"AAAA;;;;;iDAKiD;;AAEjD,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;;EAEtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,uBAAuB;EACvB,uBAAuB;;EAEvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;;EAEvB,kBAAkB;EAClB,wBAAwB;;EAExB,iBAAiB;EACjB,uBAAuB;;EAEvB,kBAAkB;EAClB,wBAAwB;;EAExB,YAAY;EACZ,4CAA4C;EAC5C,8CAA8C;EAC9C,gDAAgD;EAChD,gDAAgD;;EAEhD,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;;EAEjB,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;;EAEtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,uBAAuB;EACvB,uBAAuB;;EAEvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;;EAEvB,kBAAkB;EAClB,wBAAwB;;EAExB,iBAAiB;EACjB,uBAAuB;;EAEvB,kBAAkB;EAClB,wBAAwB;;EAExB,2CAA2C;EAC3C,8CAA8C;EAC9C,gDAAgD;EAChD,gDAAgD;AAClD;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uGAAuG;EACvG,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,2EAA2E;AAC7E;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,2BAA2B;AAC3B;EACE,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;;EAER,gBAAgB;EAChB,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,YAAY;EACZ,+BAA+B;;EAE/B,iCAAiC;EACjC,cAAc;;EAEd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,sCAAsC;;EAEtC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,8BAA8B;EAC9B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;;;EAGE,WAAW;EACX,YAAY;EACZ,eAAe;;EAEf,eAAe;EACf,oBAAoB;;EAEpB,6BAA6B;EAC7B,0BAA0B;;EAE1B,qCAAqC;EACrC,+BAA+B;;EAE/B,sCAAsC;AACxC;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,SAAS;;EAET,kBAAkB;;EAElB,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;;EAE/B,eAAe;;EAEf,sCAAsC;;EAEtC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE;IACE,+BAA+B;IAC/B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,SAAS;;EAET,kBAAkB;;EAElB,4CAA4C;;EAE5C,6BAA6B;;EAE7B,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,4EAA4E;AAC5E;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE;IACE,8DAA8D;IAC9D,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;;EAEV,8BAA8B;EAC9B,0BAA0B;;EAE1B,kBAAkB;;EAElB,eAAe;AACjB;;AAEA;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,QAAQ;;EAER,8BAA8B;EAC9B,0BAA0B;;EAE1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,cAAc;;EAEd,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;;EAEhB,6BAA6B;EAC7B,+BAA+B;;EAE/B,4BAA4B;;EAE5B,aAAa;EACb,sBAAsB;;EAEtB,gBAAgB;;EAEhB,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;;EAEzC,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;;EAER,mBAAmB;;EAEnB,aAAa;;EAEb,aAAa;EACb,sBAAsB;;EAEtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;;EAEb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;;EAEP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;;EAEX,WAAW;EACX,YAAY;;EAEZ,yBAAyB;EACzB,cAAc;;EAEd,YAAY;EACZ,kBAAkB;;EAElB,eAAe;EACf,iBAAiB;;EAEjB,eAAe;;EAEf,eAAe;;EAEf,4BAA4B;;EAE5B,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;;EAEnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;;EAEnB,sBAAsB;;EAEtB,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA,gCAAgC;AAChC;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,4BAA4B,EAAE;AACrC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;;EAET,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;;EAEV,6CAA6C;;EAE7C,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;;EAEnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,uCAAuC;EACvC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,kCAAkC;AAClC;;EAEE,UAAU;AACZ;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,uCAAuC;AACvC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,aAAa;IACb,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,yDAAyD;EAC3D;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B;EACE;;;IAGE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA;;EAEE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* ===============================================\n   MODERN PLAYLIST MANAGER\n   - Dark/Light Theme Support\n   - Mobile & Desktop Responsive\n   - Clean, Professional Design\n=============================================== */\n\n/* ===== CSS VARIABLES (THEME SYSTEM) ===== */\n:root {\n  /* Light Theme Colors */\n  --bg-primary: #ffffff;\n  --bg-secondary: #f8f9fa;\n  --bg-tertiary: #f1f3f5;\n  \n  --text-primary: #1a1a1a;\n  --text-secondary: #4a5568;\n  --text-tertiary: #718096;\n  \n  --border-color: #e2e8f0;\n  --border-hover: #cbd5e0;\n  \n  --accent-primary: #3b82f6;\n  --accent-hover: #2563eb;\n  --accent-light: #dbeafe;\n  \n  --success: #10b981;\n  --success-light: #d1fae5;\n  \n  --danger: #ef4444;\n  --danger-light: #fee2e2;\n  \n  --warning: #f59e0b;\n  --warning-light: #fef3c7;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  \n  /* Spacing */\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 14px;\n  \n  /* Transitions */\n  --transition-fast: 150ms ease;\n  --transition-base: 200ms ease;\n  --transition-slow: 300ms ease;\n}\n\n/* ===== DARK THEME ===== */\n[data-theme=\"dark\"] {\n  --bg-primary: #0f172a;\n  --bg-secondary: #1e293b;\n  --bg-tertiary: #334155;\n  \n  --text-primary: #f1f5f9;\n  --text-secondary: #cbd5e1;\n  --text-tertiary: #94a3b8;\n  \n  --border-color: #334155;\n  --border-hover: #475569;\n  \n  --accent-primary: #3b82f6;\n  --accent-hover: #60a5fa;\n  --accent-light: #1e3a8a;\n  \n  --success: #10b981;\n  --success-light: #064e3b;\n  \n  --danger: #ef4444;\n  --danger-light: #7f1d1d;\n  \n  --warning: #f59e0b;\n  --warning-light: #78350f;\n  \n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.5);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.5);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.5);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.5);\n}\n\n/* ===== BASE STYLES ===== */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  line-height: 1.6;\n  transition: background var(--transition-base), color var(--transition-base);\n}\n\n/* ===== PLAYLIST PAGE CONTAINER ===== */\n.playlist-page {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 24px;\n  min-height: 100vh;\n}\n\n@media (max-width: 768px) {\n  .playlist-page {\n    padding: 16px;\n  }\n}\n\n/* ===== TYPOGRAPHY ===== */\n.playlist-page h1 {\n  font-size: clamp(24px, 5vw, 32px);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 24px;\n  letter-spacing: -0.02em;\n}\n\n.playlist-page h2 {\n  font-size: clamp(20px, 4vw, 24px);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 32px 0 16px;\n}\n\n.playlist-page h3 {\n  font-size: clamp(16px, 3vw, 18px);\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin: 24px 0 12px;\n}\n\n/* ===== BUTTON SYSTEM ===== */\n.playlist-page button,\n.playlist-page .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  \n  min-height: 44px;\n  padding: 12px 20px;\n  \n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  \n  border: none;\n  border-radius: var(--radius-md);\n  \n  background: var(--accent-primary);\n  color: #ffffff;\n  \n  cursor: pointer;\n  user-select: none;\n  \n  transition: all var(--transition-fast);\n  \n  box-shadow: var(--shadow-sm);\n}\n\n.playlist-page button:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.playlist-page button:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-sm);\n}\n\n.playlist-page button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Button Variants */\n.playlist-page button.secondary {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: none;\n}\n\n.playlist-page button.secondary:hover {\n  background: var(--bg-secondary);\n  border-color: var(--border-hover);\n}\n\n.playlist-page button.danger {\n  background: transparent;\n  color: var(--danger);\n  box-shadow: none;\n  padding: 8px 12px;\n  min-height: auto;\n}\n\n.playlist-page button.danger:hover {\n  background: var(--danger-light);\n  transform: scale(1.05);\n}\n\n.playlist-page button.selected {\n  background: var(--accent-light);\n  color: var(--accent-primary);\n  border: 2px solid var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.playlist-page button.icon-only {\n  width: 44px;\n  padding: 0;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n}\n\n.playlist-page button.icon-only:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n/* ===== INPUT FIELDS ===== */\n.playlist-page input[type=\"text\"],\n.playlist-page input[type=\"number\"],\n.playlist-page select {\n  width: 100%;\n  height: 44px;\n  padding: 0 16px;\n  \n  font-size: 14px;\n  font-family: inherit;\n  \n  background: var(--bg-primary);\n  color: var(--text-primary);\n  \n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  \n  transition: all var(--transition-fast);\n}\n\n.playlist-page input:focus,\n.playlist-page select:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.playlist-page input::placeholder {\n  color: var(--text-tertiary);\n}\n\n.duration-input {\n  width: 80px !important;\n}\n\n/* ===== PLAYLIST ADD SECTION ===== */\n.playlist-add {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 24px;\n  padding: 20px;\n  background: var(--bg-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n@media (max-width: 768px) {\n  .playlist-add {\n    flex-direction: column;\n  }\n  \n  .playlist-add input {\n    width: 100%;\n  }\n}\n\n/* ===== PLAYLIST LIST ===== */\n.playlist-list {\n  display: grid;\n  gap: 12px;\n  margin-bottom: 32px;\n}\n\n.playlist-row {\n  display: grid;\n  grid-template-columns: 1fr auto auto auto auto;\n  align-items: center;\n  gap: 16px;\n  \n  padding: 16px 20px;\n  \n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  \n  cursor: pointer;\n  \n  transition: all var(--transition-fast);\n  \n  box-shadow: var(--shadow-sm);\n}\n\n.playlist-row:hover {\n  border-color: var(--accent-primary);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.playlist-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--accent-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.playlist-row span {\n  font-size: 14px;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .playlist-row {\n    grid-template-columns: 1fr auto;\n    gap: 12px;\n  }\n  \n  .playlist-row span {\n    grid-column: 1 / -1;\n    font-size: 12px;\n  }\n}\n\n/* ===== ASSET LIST ===== */\n.asset-list {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 24px;\n}\n.asset-index {\n  font-weight: 700;\n  color: var(--text-secondary);\n  width: 30px;\n  text-align: center;\n  background: var(--bg-tertiary);\n  border-radius: 6px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n.asset-row {\n  display: grid;\n  grid-template-columns: 40px 80px minmax(0, 1fr) auto auto auto;\n  align-items: center;\n  gap: 16px;\n\n  padding: 12px 16px;\n\n  border-bottom: 1px solid var(--border-color);\n\n  background: var(--bg-primary);\n\n  transition: all var(--transition-fast);\n}\n.asset-index-placeholder {\n  width: 30px;\n}\n.asset-row:last-child {\n  border-bottom: none;\n}\n\n.asset-row:hover {\n  background: var(--bg-secondary);\n}\n\n.asset-row.selected {\n  background: var(--bg-secondary);\n  cursor: pointer;\n}\n\n/* Keep checkbox in same column (5) in unselected list so it doesn't shift */\n.unselected-list .asset-row input[type=\"checkbox\"] {\n  grid-column: 5;\n}\n\n.asset-row:active {\n  cursor: grabbing;\n}\n\n.asset-row img,\n.asset-row video {\n  width: 80px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: var(--radius-sm);\n  box-shadow: var(--shadow-sm);\n  flex-shrink: 0;\n  min-width: 0;\n}\n\n.asset-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.asset-info span {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.asset-info small {\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n\n@media (max-width: 768px) {\n  .asset-row {\n    grid-template-columns: 30px 60px minmax(0, 1fr) auto auto auto;\n    gap: 12px;\n  }\n  .asset-info{\n    text-align: center;\n  }\n\n  .asset-row img,\n  .asset-row video {\n    width: 60px;\n    height: 45px;\n  }\n}\n\n/* ===== PLAYLIST ASSETS (GRID VIEW) ===== */\n.playlist-assets {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.playlist-asset {\n  position: relative;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  transition: all var(--transition-fast);\n}\n\n.playlist-asset:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-lg);\n}\n\n.playlist-asset img {\n  width: 100%;\n  height: 120px;\n  object-fit: cover;\n  display: block;\n}\n\n.playlist-asset button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 32px;\n  height: 32px;\n  min-height: auto;\n  padding: 0;\n  \n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(8px);\n  \n  border-radius: 50%;\n  \n  font-size: 18px;\n}\n\n@media (max-width: 768px) {\n  .playlist-assets {\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n    gap: 12px;\n  }\n  \n  .playlist-asset img {\n    height: 90px;\n  }\n}\n\n/* ===== MODAL SYSTEM ===== */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  \n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  z-index: 10000;\n  \n  animation: fadeIn var(--transition-base);\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.modal {\n  width: 700px;\n  max-width: 95vw;\n  max-height: 90vh;\n  \n  background: var(--bg-primary);\n  border-radius: var(--radius-lg);\n  \n  box-shadow: var(--shadow-xl);\n  \n  display: flex;\n  flex-direction: column;\n  \n  overflow: hidden;\n  \n  animation: slideUp var(--transition-slow);\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.modal-body {\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto;\n}\n\n.modal-footer {\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-color);\n  \n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n@media (max-width: 768px) {\n  .modal {\n    max-width: 100vw;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n}\n\n/* ===== PREVIEW OVERLAY ===== */\n.preview-overlay {\n  position: fixed;\n  inset: 0;\n  \n  background: #000000;\n  \n  z-index: 9999;\n  \n  display: flex;\n  flex-direction: column;\n  \n  overflow: hidden;\n}\n\n.preview-stage {\n  width: 100vw;\n  height: 100vh;\n  \n  display: flex;\n  flex-direction: column;\n}\n\n.preview-media-wrapper {\n  flex: 1;\n  \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  overflow: hidden;\n}\n\n.preview-media {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.preview-media.cover {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.preview-close {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  \n  width: 48px;\n  height: 48px;\n  \n  background: var(--danger);\n  color: #ffffff;\n  \n  border: none;\n  border-radius: 50%;\n  \n  font-size: 24px;\n  font-weight: bold;\n  \n  cursor: pointer;\n  \n  z-index: 999999;\n  \n  box-shadow: var(--shadow-xl);\n  \n  transition: all var(--transition-fast);\n}\n\n.preview-close:hover {\n  background: #dc2626;\n  transform: scale(1.1);\n}\n\n/* ===== TICKER SYSTEM ===== */\n.display-ticker {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  \n  display: flex;\n  align-items: center;\n  \n  z-index: 10001;\n}\n\n.display-ticker-track {\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  \n  will-change: transform;\n  \n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n}\n\n.ticker-item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.display-ticker.landscape .ticker-item {\n  margin-right: 80px;\n}\n\n.display-ticker-text {\n  display: inline-block;\n  font-weight: 600;\n  letter-spacing: 1px;\n  transform: skewX(-12deg);\n  line-height: 1;\n  padding-top: 2px;\n  color: inherit;\n  text-shadow: 0 0 6px currentColor;\n}\n\n/* Landscape Ticker Animations */\n.display-ticker.landscape.left .display-ticker-track {\n  animation-name: display-ticker-left;\n}\n\n.display-ticker.landscape.right .display-ticker-track {\n  animation-name: display-ticker-right;\n}\n\n@keyframes display-ticker-left {\n  from { transform: translateX(100vw); }\n  to { transform: translateX(-100%); }\n}\n\n@keyframes display-ticker-right {\n  from { transform: translateX(-100%); }\n  to { transform: translateX(100vw); }\n}\n\n/* Portrait Ticker */\n.display-ticker.portrait {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 60px;\n  height: 100%;\n  overflow: hidden;\n}\n\n.display-ticker.portrait .display-ticker-track {\n  position: absolute;\n  left: 50%;\n  \n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 240px;\n  \n  transform: translateX(-50%) translateY(-120%);\n  \n  animation-name: ticker-portrait;\n}\n\n.display-ticker.portrait .display-ticker-text {\n  display: inline-block;\n  white-space: nowrap;\n  \n  transform: rotate(-90deg);\n  transform-origin: center;\n}\n\n@keyframes ticker-portrait {\n  from {\n    transform: translateX(-50%) translateY(-120%);\n  }\n  to {\n    transform: translateX(-50%) translateY(120%);\n  }\n}\n\n/* Ticker Speeds */\n.display-ticker.slow .display-ticker-track {\n  animation-duration: 30s;\n}\n\n.display-ticker.medium .display-ticker-track {\n  animation-duration: 15s;\n}\n\n.display-ticker.fast .display-ticker-track {\n  animation-duration: 8s;\n}\n\n/* ===== COPY BUTTON ===== */\n.copy-btn {\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  font-size: 18px;\n  padding: 8px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  border-radius: var(--radius-sm);\n}\n\n.copy-btn:hover {\n  background: var(--bg-secondary);\n  color: var(--accent-primary);\n}\n\n/* ===== UTILITY CLASSES ===== */\n.text-muted {\n  color: var(--text-tertiary);\n}\n\n.text-success {\n  color: var(--success);\n}\n\n.text-danger {\n  color: var(--danger);\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 999px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n}\n\n.badge.success {\n  background: var(--success-light);\n  color: var(--success);\n}\n\n.badge.danger {\n  background: var(--danger-light);\n  color: var(--danger);\n}\n\n/* ===== LOADING STATES ===== */\n.loading {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--accent-primary);\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ===== SCROLLBAR STYLING ===== */\n.modal-body::-webkit-scrollbar,\n.asset-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.modal-body::-webkit-scrollbar-track,\n.asset-list::-webkit-scrollbar-track {\n  background: var(--bg-secondary);\n}\n\n.modal-body::-webkit-scrollbar-thumb,\n.asset-list::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 4px;\n}\n\n.modal-body::-webkit-scrollbar-thumb:hover,\n.asset-list::-webkit-scrollbar-thumb:hover {\n  background: var(--border-hover);\n}\n\n/* ===== RESPONSIVE BREAKPOINTS ===== */\n@media (max-width: 480px) {\n  .playlist-page h1 {\n    font-size: 24px;\n  }\n  \n  .playlist-header {\n    padding: 12px;\n    display: flex;\n  }\n  \n  .playlist-row {\n    padding: 12px;\n    display: flex;\n    gap: 20px;\n  }\n  \n  .asset-row {\n    padding: 10px;\n    grid-template-columns: 60px minmax(0, 1fr) auto auto auto;\n  }\n  \n  .modal-header,\n  .modal-body,\n  .modal-footer {\n    padding: 16px;\n  }\n}\n\n/* ===== PRINT STYLES ===== */\n@media print {\n  .playlist-page button,\n  .preview-close,\n  .copy-btn {\n    display: none;\n  }\n  \n  .playlist-page {\n    padding: 0;\n  }\n  \n  .asset-row,\n  .playlist-row {\n    box-shadow: none;\n    border: 1px solid #ddd;\n  }\n}\n\n/* ===== ACCESSIBILITY ===== */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n.playlist-page button:focus-visible,\n.playlist-page input:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n/* ===== HIGH CONTRAST MODE ===== */\n@media (prefers-contrast: high) {\n  :root {\n    --border-color: #000000;\n    --text-secondary: #000000;\n  }\n  \n  [data-theme=\"dark\"] {\n    --border-color: #ffffff;\n    --text-secondary: #ffffff;\n  }\n}\n\n.selected-assets-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 18px 0 10px;\n}\n\n.selected-assets-header h3 {\n  margin: 0;\n  font-size: 16px;\n}\n\n.selected-assets-header span {\n  font-size: 14px;\n  opacity: 0.8;\n}\n.available-assets-header {\n  margin: 24px 0 10px;\n}\n\n.available-assets-header h3 {\n  margin: 0;\n  font-size: 16px;\n}\n* {\n  outline: none;\n}\nh2.section-title {\n  font-size: clamp(18px, 2vw, 22px);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
